import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ProviderDashboardWarningsQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ProviderDashboardWarningsQueryResultFragment } from '@docpace/shared-graphql'

const typedProviderDashboardWarningsQueryDocument = ProviderDashboardWarningsQueryDocument as TypedDocumentNode<ProviderDashboardWarningsQueryResultFragment>

export function useProviderDashboardWarningsQuery(opts?: useQuery.Options<ProviderDashboardWarningsQueryResultFragment>){
    return useQuery(typedProviderDashboardWarningsQueryDocument, opts)
}
